import { render, staticRenderFns } from "./AreaEmbargadaSc.vue?vue&type=template&id=1b214b46&lang=pug"
import script from "./AreaEmbargadaSc.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports